<div class="ickahra kareli">
  <div class="sar">
    <p class="etiket">Öğrenci / veli</p>
    <h1 class="h1" style="margin-top:16px">Günde bir liste. <span class="vurgu">Bitince biter.</span></h1>
    <p class="giris-p">Sonsuz soru bankasında kaybolmak yok. pratiu bugün sana hangi soruların lazım olduğunu bilir; listeyi bitirdiğinde o gün için işin tamamdır.</p>
    <div class="hero-btn">
      <a class="btn kirmizi" href="https://app.pratiu.com" target="_blank" rel="noopener">Sınıf kodunla gir <svg><use xlink:href="#i-ok"></use></svg></a>
      <a class="btn ikincil" href="https://app.pratiu.com" target="_blank" rel="noopener">Çalışma ekranını gör</a>
    </div>
    <div class="sayac">
      <div><span class="sayi">12–18</span><span class="etiket">günlük ortalama soru</span></div>
      <div><span class="sayi">~9 dk</span><span class="etiket">günlük süre</span></div>
      <div><span class="sayi">0</span><span class="etiket">sınıf sıralaması</span></div>
    </div>
  </div>
</div>

<div class="sar bol">
  <div class="bol-bas"><span class="etiket">Öğrenci için</span><h2 class="h2">Az ama tam zamanında.</h2></div>
  <div class="g3">
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-saat"></use></svg></div><h4 class="h4">Bugünün listesi</h4><p>Unutmaya başladığın konular öne gelir. Yeni konu ile eski konu aynı listede karışık gelir — sınavdaki gibi.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-dongu"></use></svg></div><h4 class="h4">Kendi hızını sen söyle</h4><p>Cevaptan sonra "kolaydı" ya da "zordu" dersin. Soru ona göre uzaklaşır ya da yakınlaşır.</p></div>
    <div class="ozet"><div class="rk"><svg><use xlink:href="#i-hedef"></use></svg></div><h4 class="h4">Yanlış, aynı ekranda çözülür</h4><p>Doğru cevabı görmekle kalmazsın; nerede saptığını adım adım okursun.</p></div>
  </div>
</div>

<div style="border-top:1px solid var(--cizgi);background:var(--kagit-2)">
  <div class="sar bol">
    <div class="aciklama">
      <div>
        <span class="etiket">Veli için</span>
        <h2 class="h2" style="margin:14px 0 18px">Sıralama değil, gelişim.</h2>
        <p>Veli ekranında başka çocukların netleri yoktur. Sadece kendi çocuğunuzun hangi kazanımda ilerlediği, hangisinde takıldığı ve son otuz günde ne kadar düzenli çalıştığı görünür.</p>
        <p>Amaç, evde "kaçıncı oldun" konuşmasını "hangi konu zor geliyor" konuşmasıyla değiştirmek.</p>
        <ul class="tik" style="margin-top:18px">
          <li><svg><use xlink:href="#i-tik"></use></svg><span>Haftalık özet, tek e-posta</span></li>
          <li><svg><use xlink:href="#i-tik"></use></svg><span>Kazanım bazlı gelişim çizgisi</span></li>
          <li><svg><use xlink:href="#i-tik"></use></svg><span>Öğretmenin açtığı kadar erişim — fazlası değil</span></li>
        </ul>
      </div>
      <div class="kart">
        <div class="kart-bas"><h3 class="h3">Bu haftaki gelişim</h3><span class="rozet ye">▲ 3 kazanım</span></div>
        <div style="padding:18px">
          <div class="serit">
            <div class="durak bugun"><div class="sut" style="height:60px"><span class="n">14</span></div><div class="cz"></div><span class="lbl">1g</span></div>
            <div class="durak"><div class="sut" style="height:44px"><span class="n">9</span></div><div class="cz"></div><span class="lbl">3g</span></div>
            <div class="durak"><div class="sut" style="height:86px"><span class="n">21</span></div><div class="cz"></div><span class="lbl">7g</span></div>
            <div class="durak"><div class="sut" style="height:110px"><span class="n">27</span></div><div class="cz"></div><span class="lbl">16g</span></div>
            <div class="durak"><div class="sut" style="height:74px"><span class="n">18</span></div><div class="cz"></div><span class="lbl">35g</span></div>
            <div class="durak"><div class="sut" style="height:126px;background:var(--yesil)"><span class="n">31</span></div><div class="cz"></div><span class="lbl">90g</span></div>
          </div>
          <p class="soluk" style="font-size:13px;margin-top:16px;padding-top:14px;border-top:1px solid var(--kagit-3)">
            Yeşile geçen 31 kazanım artık kalıcı sayılıyor. Kırmızıdaki 14 kazanım bugün tekrar edilecek.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="cta">
  <div class="cta-ic">
    <div><h2 class="h2">Sınıf kodun var mı?</h2><p>Öğretmeninin verdiği kodla gir, bugünün listesi hazır olsun.</p></div>
    <a class="btn kirmizi" href="https://app.pratiu.com" target="_blank" rel="noopener">Giriş yap <svg><use xlink:href="#i-ok"></use></svg></a>
  </div>
</div>
